"use strict";

import React, { useState, useLayoutEffect, useEffect } from "react";
import { createPortal } from "react-dom";
import SwiperCore, { Thumbs, Navigation, Lazy, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import size from "../../size";
import ProductGalleryToolbar from "./ProductGalleryToolbar";
import ProductGallerySlide from "./ProductGallerySlide";
import ProductGalleryThumbnailSlide from "./ProductGalleryThumbnailSlide";

SwiperCore.use([Thumbs, Navigation, Lazy, Pagination]);

const ProductGalleryMediumUp = ({
    slides = [],
    currentIndex = 0,
    isMediumUp = false,
    isFullScreen = false,
    lazyLoading = {},
    onSlideChange = () => {},
    onFullScreenClick = () => {},
}) => {
    const [galleryController, setGalleryController] = useState(null);
    const [galleryThumbController, setGalleryThumbController] = useState(null);
    const [isAtBeginning, setIsAtBeginning] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);
    const loopedSlides = !!slides.length && slides.length >= 3 ? 3 : 0;

    const galleryLoop = false;

    const thumbnailLoop = false;
    const thumbnailSlidesPerView = 4;
    const thumbnailSlideToClickedSlide = true;

    const mediumUpGalleryEl = document.getElementById("product-detail__slides__component--medium-up");
    const serverRenderedDisplay = !!mediumUpGalleryEl && mediumUpGalleryEl.querySelector("[data-images-list]");
    const wrapperStyle = {};
    const spaceBetween = 10;

    useLayoutEffect(() => {
        if (!!mediumUpGalleryEl) {
            mediumUpGalleryEl.style.minHeight = `${size.outerHeight(mediumUpGalleryEl)}px`;
            mediumUpGalleryEl.style.position = `relative`;
            if (!!serverRenderedDisplay) {
                serverRenderedDisplay.style.position = "absolute";
                serverRenderedDisplay.style.top = "0";
                serverRenderedDisplay.style.left = "0";
                serverRenderedDisplay.style.right = "0";
                serverRenderedDisplay.style.marginBottom = "1.25rem";
            }
            mediumUpGalleryEl.offsetHeight;
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (!!mediumUpGalleryEl) mediumUpGalleryEl.style.minHeight = "auto";
            if (!!serverRenderedDisplay && serverRenderedDisplay.parentNode)
                serverRenderedDisplay.parentNode.removeChild(serverRenderedDisplay);
        }, 1000);
    }, []);

    useEffect(() => {
        if (!isMediumUp || isFullScreen) {
            setGalleryThumbController(null);
        }
    }, [isMediumUp, isFullScreen]);

    if (!!mediumUpGalleryEl) {
        return createPortal(
            <div style={wrapperStyle}>
                {!!slides.length && isMediumUp && !isFullScreen && (
                    <React.Fragment>
                        {(slides.length === 1 && (
                            <React.Fragment>
                                <ul className="product-images__list slides">
                                    <li className="product-images__list-item slide slide--active">
                                        <ProductGallerySlide slide={slides[0]} slideAltText={`Product Image`} />
                                    </li>
                                </ul>
                                <ProductGalleryToolbar
                                    className="product-detail__slides__toolbar__container--medium-up"
                                    style={{ borderBottom: "1px solid #bbbbbb" }}
                                    index={currentIndex}
                                    slidesLength={slides.length}
                                    onFullScreenClick={onFullScreenClick}
                                />
                            </React.Fragment>
                        )) || (
                            <React.Fragment>
                                <Swiper
                                    thumbs={{ swiper: galleryThumbController }}
                                    className={"product-detail__slides__container"}
                                    tag="div"
                                    wrapperTag="ul"
                                    navigation
                                    slidesPerView={1}
                                    grabCursor={false}
                                    simulateTouch={false}
                                    loop={galleryLoop}
                                    loopedSlides={loopedSlides}
                                    spaceBetween={spaceBetween}
                                    onSwiper={(swiper) => {
                                        swiper.slideToLoop(currentIndex);
                                        swiper.on("slideChange", function () {
                                            onSlideChange(swiper);
                                        });
                                    }}>
                                    {slides.map((slide, index) => (
                                        <SwiperSlide tag="li" style={{}} key={`slideKey1-${index}`}>
                                            <ProductGallerySlide slide={slide} slideAltText={`Product Image`} />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <ProductGalleryToolbar
                                    className="product-detail__slides__toolbar__container--medium-up"
                                    index={currentIndex}
                                    slidesLength={slides.length}
                                    onFullScreenClick={onFullScreenClick}
                                />
                                <div
                                    className="product-detail__slides__thumbnail__container"
                                    style={{
                                        position: "relative",
                                        padding: "0 30px",
                                        marginTop: "10px",
                                        userSelect: "none",
                                        WebkitUserSelect: "none",
                                        MozUserSelect: "none",
                                        msUserSelect: "none",
                                        WebkitTouchCallout: "none",
                                        WebkitTapHighlightColor: "transparent",
                                    }}>
                                    <div
                                        className="thumbnail-swiper-button-prev"
                                        style={{
                                            position: "absolute",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            zIndex: 10,
                                            cursor: "pointer",
                                            background: "transparent !important",
                                            borderRadius: "50%",
                                            padding: "5px",
                                            boxShadow: "none !important",
                                            display: slides.length <= thumbnailSlidesPerView ? "none" : "block",
                                        }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke={isAtBeginning ? "#B4CDE1" : "#268de1"}
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round">
                                            <polyline points="15 18 9 12 15 6"></polyline>
                                        </svg>
                                    </div>
                                    <div
                                        className="thumbnail-swiper-button-next"
                                        style={{
                                            position: "absolute",
                                            right: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            zIndex: 10,
                                            cursor: "pointer",
                                            background: "transparent !important",
                                            borderRadius: "50%",
                                            padding: "5px",
                                            boxShadow: "none !important",
                                            display: slides.length <= thumbnailSlidesPerView ? "none" : "block",
                                        }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke={isAtEnd ? "#B4CDE1" : "#268de1"}
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg>
                                    </div>
                                    <Swiper
                                        tag="div"
                                        wrapperTag="ul"
                                        slidesPerView={thumbnailSlidesPerView}
                                        watchSlidesProgress={true}
                                        watchSlidesVisibility={true}
                                        spaceBetween={spaceBetween}
                                        loop={thumbnailLoop}
                                        loopedSlides={loopedSlides}
                                        navigation={{
                                            nextEl: ".thumbnail-swiper-button-next",
                                            prevEl: ".thumbnail-swiper-button-prev",
                                        }}
                                        lazy={{
                                            loadPrevNext: true,
                                            preloaderClass: lazyLoading.preLoaderClassName || "",
                                        }}
                                        onSwiper={(swiper) => {
                                            setGalleryThumbController(() => {
                                                return swiper;
                                            });

                                            // Set initial state
                                            setIsAtBeginning(swiper.isBeginning);
                                            setIsAtEnd(swiper.isEnd);

                                            // Listen for slide changes
                                            swiper.on("slideChange", function () {
                                                setIsAtBeginning(swiper.isBeginning);
                                                setIsAtEnd(swiper.isEnd);
                                                swiper.lazy.load();
                                            });

                                            swiper.once("slideChange", function () {
                                                swiper.lazy.load();
                                            });
                                        }}>
                                        {slides.map((slide, index) => (
                                            <SwiperSlide
                                                tag="li"
                                                key={`slideThumb1-${index}`}
                                                style={{ background: "#eeeeee" }}>
                                                <ProductGalleryThumbnailSlide
                                                    thumbnail={slide}
                                                    imgAlt={"Product Slide Thumbnail"}
                                                    lazyLoad={index > 2}
                                                    lazyLoading={lazyLoading}
                                                />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </div>,
            mediumUpGalleryEl
        );
    } else return null;
};

export default ProductGalleryMediumUp;
